import { PayloadAction } from "@reduxjs/toolkit";
import {
  AccountPaymentVerificationResponseType,
  AuthType,
  GetUserProfileType,
  LoginResponseType,
  UserProfileType,
} from "./authTypes";

export const authReducer = {
  resetError: (state: AuthType) => {
    state.error = null;
  },
  resetSuccess: (state: AuthType) => {
    state.success = null;
  },
  resetAttendenceError: (state: AuthType) => {
    state.attendenceError = null;
  },
  resetAttendenceSuccess: (state: AuthType) => {
    state.attendenceSuccess = null;
  },
  setClientCurrencyDetails: (state: AuthType, { payload }: any) => {
    state.currencyName = payload.currencyName;
    state.currencySign = !payload.currencyName
      ? "₹"
      : payload.currencySign
        ? payload.currencySign
        : "";
    state.currencyShortForm = payload.currencyShortForm;
  },
  resetSession: (state: AuthType) => {
    state.token = null;
    state.loginData = {} as LoginResponseType;
    state.allGroupMenus = [];
    state.sideMenus = [];
    state.modules = [];
    state.others = [];
    state.userDetails = [];
    state.individualClientList = [];
    state.assignedClientsToUserList = [];
    state.favouriteClientsData = [];
    state.unFavouriteClientsData = [];
    state.finacUsersList = [];
    state.finacClientsList = [];
    state.finacClientUsersList = [];
    state.clientCodeList = [];
    state.attendenceData = [];
  },
  resetUserDetails: (state: AuthType) => {
    state.userDetails = [];
  },
  resetClientList: (state: AuthType) => {
    state.clientList = [];
  },
  resetIndividualClientList: (state: AuthType) => {
    state.individualClientList = [];
  },
  resetAuthFetching: (state: AuthType) => {
    state.fetching = false;
  },
  resetResetPasswordToken: (state: AuthType) => {
    state.resetPasswordToken = null;
  },
  resetAllGroupMenuList: (state: AuthType) => {
    state.allGroupMenus = [];
  },
  resetUserProfiledata: (state: AuthType) => {
    state.userProfiledata = {} as GetUserProfileType;
  },
  resetUserProfileAllData: (state: AuthType) => {
    state.userProfileAllData = {} as UserProfileType;
  },
  resetPersistUserProfileAllData: (state: AuthType) => {
    state.persistUserProfileAllData = {} as UserProfileType;
  },
  resetAssignedClientsToUserList: (state: AuthType) => {
    state.assignedClientsToUserList = [];
  },
  resetFavouriteClientToUserList: (state: AuthType) => {
    state.favouriteClientsData = [];
  },
  resetUnFavouriteClientToUserList: (state: AuthType) => {
    state.unFavouriteClientsData = [];
  },
  resetFinacUsersList: (state: AuthType) => {
    state.finacUsersList = [];
  },
  resetFinacClientUsersList: (state: AuthType) => {
    state.finacClientUsersList = [];
  },
  resetFinacManagerList: (state: AuthType) => {
    state.finacManagerList = [];
  },
  resetFinacPartnerList: (state: AuthType) => {
    state.finacPartnerList = [];
  },
  resetAuthMessage: (state: AuthType) => {
    state.message = null;
  },
  resetAllAssignUserOfSingleClient: (state: AuthType) => {
    state.allAssignUserOfSingleClient.data = [];
  },
  resetTotalUserCount: (state: AuthType) => {
    state.totalUserCount = "";
  },
  resetTotalManagerCount: (state: AuthType) => {
    state.totalManagerCount = "";
  },
  resetTotalClientsCount: (state: AuthType) => {
    state.totalClientsCount = null;
  },
  resetEmailSuccess: (state: AuthType) => {
    state.emailSuccess = null;
  },
  resetEmailSatusCode: (state: AuthType) => {
    state.emailSatusCode = null;
  },
  resetEmailError: (state: AuthType) => {
    state.emailError = "";
  },
  resetEmailMessage: (state: AuthType) => {
    state.emailMessage = "";
  },
  resetRecruitmentTrackerUniqueEmailMessage: (state: AuthType) => {
    state.recruitmentTrackerUniqueEmailMessage = "";
  },
  resetRecruitmentTrackerUniqueMobileMessage: (state: AuthType) => {
    state.recruitmentTrackerUniqueMobileMessage = "";
  },
  resetEmailFetching: (state: AuthType) => {
    state.emailFetching = false;
  },
  resetIsEmail: (state: AuthType) => {
    state.isEmail = null;
  },
  resetMobileSuccess: (state: AuthType) => {
    state.mobileSuccess = null;
  },
  resetMobileSatusCode: (state: AuthType) => {
    state.mobileSatusCode = null;
  },
  resetMobileError: (state: AuthType) => {
    state.mobileError = "";
  },
  resetMobileMessage: (state: AuthType) => {
    state.mobileMessage = "";
  },
  resetMobileFetching: (state: AuthType) => {
    state.mobileFetching = false;
  },
  resetIsMobileNo: (state: AuthType) => {
    state.isMobileNo = null;
  },
  resetAttendenceData: (state: AuthType) => {
    state.attendenceData = [];
  },
  resetAttendanceStatusCode: (state: AuthType) => {
    state.attendanceStatusCode = null;
  },
  setLocationDetails: (state: AuthType, { payload }: any) => {
    state.location = payload;
  },
  resetLocationDetails: (state: AuthType) => {
    state.location = "";
  },
  resetTotalUnfavouriteClient: (state: AuthType) => {
    state.totalUnfavouriteClient = 0;
  },
  setCompanyName: (state: AuthType, action: PayloadAction<string, string>) => {
    state.companyName = action.payload;
  },
  resetCompanyName: (state: AuthType) => {
    state.companyName = "";
  },
  resetSignUpEmailSuccess: (state: AuthType) => {
    state.signUpEmailSuccess = null;
  },
  resetSignUpEmailSatusCode: (state: AuthType) => {
    state.signUpEmailSatusCode = null;
  },
  resetSignUpEmailError: (state: AuthType) => {
    state.signUpEmailError = "";
  },
  resetSignUpEmailMessage: (state: AuthType) => {
    state.signUpEmailMessage = "";
  },
  resetSignUpEmailFetching: (state: AuthType) => {
    state.signUpEmailFetching = false;
  },
  resetIsSignupEmail: (state: AuthType) => {
    state.isSignupEmail = null;
  },
  resetSignUpMobileSuccess: (state: AuthType) => {
    state.signUpMobileSuccess = null;
  },
  resetSignUpMobileSatusCode: (state: AuthType) => {
    state.signUpMobileSatusCode = null;
  },
  resetSignUpMobileError: (state: AuthType) => {
    state.signUpMobileError = "";
  },
  resetSingUpMobileMessage: (state: AuthType) => {
    state.singUpMobileMessage = "";
  },
  resetSignUpMobileFetching: (state: AuthType) => {
    state.signUpMobileFetching = false;
  },
  resetIsSignUpMobileNo: (state: AuthType) => {
    state.isSignUpMobileNo = null;
  },
  resetStateList: (state: AuthType) => {
    state.stateList = [];
  },
  resetStateListTotalCount: (state: AuthType) => {
    state.stateListTotalCount = 0;
  },
  resetStateFetching: (state: AuthType) => {
    state.stateFetching = false;
  },

  resetCityList: (state: AuthType) => {
    state.cityList = [];
  },
  resetCityListTotalCount: (state: AuthType) => {
    state.cityListTotalCount = 0;
  },
  resetCityFetching: (state: AuthType) => {
    state.cityFetching = false;
  },
  resetCountryList: (state: AuthType) => {
    state.countryList = [];
  },
  resetCountryListTotalCount: (state: AuthType) => {
    state.countryListTotalCount = 0;
  },
  resetTeamDirectoryUsersList: (state: AuthType) => {
    state.teamDirectoryUsersData = [];
  },
  resetTeamDirectoryTotalCount: (state: AuthType) => {
    state.totalTeamDirectoryUsersCount = 0;
  },

  resetCountrySuccess: (state: AuthType) => {
    state.countrySuccess = null;
  },

  resetCountryError: (state: AuthType) => {
    state.countryError = "";
  },

  resetStateError: (state: AuthType) => {
    state.stateError = "";
  },
  resetStateSuccess: (state: AuthType) => {
    state.stateSuccess = null;
  },

  resetCityError: (state: AuthType) => {
    state.cityError = "";
  },
  resetCitySuccess: (state: AuthType) => {
    state.citySuccess = null;
  },
  resetFinacGovtOfficerList: (state: AuthType) => {
    state.finacGovtOfficerList = [];
  },
  resetTotalGovtOfficerCount: (state: AuthType) => {
    state.totalGovtOfficerCount = 0;
  },
  resetTotalJobListCount: (state: AuthType) => {
    state.totalJobListCount = 0;
  },
  resetGovtOfficerJobsList: (state: AuthType) => {
    state.govtOfficerJobsList = [];
  },
  resetAuAccountNumberVerifyData: (state: AuthType) => {
    state.auAccountNumberVerifyData = {};
  },
  resetspecificPincodeInformation: (state: AuthType) => {
    state.specificPincodeInformation = []
  },
  resetVerifyVoucherSuccess: (state: AuthType) => {
    state.verifyVoucherSuccess = null;
  },
  resetVerifyVoucherMessage: (state: AuthType) => {
    state.verifyVoucherMessage = null;
  },
  resetIsAccountNumberVerified: (state: AuthType) => {
    state.isAccountNumberVerified = false
  },
  resetVerifyAccountNumberMessage: (state: AuthType) => {
    state.verifyAccountNumberMessage = null;
  },
  resetAccountPaymentVoucherVefication: (state: AuthType) => {
    state.accountPaymentVoucherVerification = {} as AccountPaymentVerificationResponseType
  },
  resetIsVoucherCodeVerified: (state: AuthType) => {
    state.isVoucherCodeVerified = false
  }



};
